// extracted by mini-css-extract-plugin
export default {"warning":"responsive-route-wrapper_warning__IllFL","content":"responsive-route-wrapper_content__1IhIO"};